import { CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib/constants/ContentPlatformPropertyName';
import { NOT_HAS_PROPERTY } from 'marketing-platform-lib/utils/filters';
export const getRequiredFiltersForEmptyState = () => {
  /*
   * The following filter corrections CANNOT be overridden by clients because they
   * are essential to consistent behavior with rendering empty states in the table
   */

  return [NOT_HAS_PROPERTY(CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID)];
};